module.exports = __webpack_public_path__ + "img/Support-skill-138.fc9b22c0.png";